<template>
  <div class="mobile">
    <div class="fullbox">
      <div class="form">
        <div class="from_title">
          <div class="left">编号: {{ object.id }}</div>
          <div class="right">
            <div class="top_state top_state1" v-if="object.state == 1">
              未归还
            </div>
            <div class="top_state top_state2" v-if="object.state == 2">
              已归还
            </div>
            <div class="top_state top_state3" v-if="object.state == 3">
              异常
            </div>
          </div>
        </div>
        <div class="filed_box">
          <div class="filed">
            <div class="filed_label"><span></span>申请人员</div>
            <div class="filed_value">{{ userinfo.nickname }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>所属部门</div>
            <div class="filed_value">{{ userinfo.department }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>联系电话</div>
            <div class="filed_value">{{ userinfo.phone }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>所属区域</div>
            <div class="filed_value">{{ object.place }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>借伞数量</div>
            <div class="filed_value">{{ object.num }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>借用时间</div>
            <div class="filed_value">{{ object.buTime }}</div>
          </div>
          <div class="filed">
            <div class="filed_label"><span></span>预计归还时间</div>
            <div class="filed_value">{{ object.planTime }}</div>
          </div>
        </div>
        <div class="from_text">
          <div class="left">
            <div class="label">已归还数量</div>
            <div class="value">{{ object.returnNum }}</div>
          </div>
          <div class="right">
            <div class="label">剩余未归还数量</div>
            <div class="value">
              {{ object.num - object.returnNum - object.errorNum }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="historyList.length > 0">
        <div
          class="form"
          v-for="item in historyList"
          :key="item.id"
          style="margin-top: 18px"
        >
          <div
            class="from_title"
            style="border-bottom: none; padding-bottom: 0"
          >
            <div class="left"></div>
            <div class="right">
              <div class="top_state top_state1" v-if="item.state == 1">
                待确认
              </div>
              <div class="top_state top_state2" v-if="item.state == 2">
                确认
              </div>
              <div class="top_state top_state3" v-if="item.state == 3">
                驳回
              </div>
            </div>
          </div>
          <div class="filed_box">
            <div class="filed">
              <div class="filed_label"><span></span>ID号</div>
              <div class="filed_value">{{ item.buRecordId }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>归还数量</div>
              <div class="filed_value">{{ item.num }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>异常记录</div>
              <div class="filed_value" v-if="item.damageNum || item.loseNum">
                丢失:{{ item.loseNum }}&emsp;损坏:{{ item.damageNum }}
              </div>
              <div class="filed_value" v-else>--</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>归还时间</div>
              <div class="filed_value">{{ item.backTime }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>备注</div>
              <div class="filed_value">{{ item.remark }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>确认人</div>
              <div class="filed_value">{{ item.disposeName }}</div>
            </div>
            <div class="filed">
              <div class="filed_label"><span></span>确认时间</div>
              <div class="filed_value">{{ item.disposeTime }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="form" style="margin-top: 18px" v-if="object.state == 1">
        <div class="filed" style="padding: 0; align-items: center">
          <div class="filed_label"><span>*</span>归还时间</div>
          <div class="filed_value">
            <van-field
              v-model="returnTime"
              placeholder="请选择还伞时间"
              readonly
              clickable
              @click="showPickerReturn = true"
              :border="false"
              class="textRight"
              disabled
            />
            <van-popup v-model="showPickerReturn" position="bottom">
              <van-datetime-picker
                type="datetime"
                v-model="currentTimeReturn"
                @confirm="onConfirmReturn"
                @cancel="showPickerReturn = false"
              />
            </van-popup>
          </div>
        </div>
        <div class="line"></div>
        <div class="filed2">
          <div class="filed_label"><span>*</span>雨伞状态</div>
          <div class="filed_value">
              <!-- <van-radio-group v-model="radio">
                <van-radio name="1" shape="square">正常</van-radio>
                <van-radio name="2" shape="square">损坏</van-radio>
                <van-radio name="3" shape="square">丢失</van-radio>
              </van-radio-group> -->
            <!-- <div class="left">
              <van-checkbox-group v-model="radio">
                <van-checkbox name="1" shape="square">正常</van-checkbox>
                <van-checkbox name="2" shape="square">损坏</van-checkbox>
                <van-checkbox name="3" shape="square">丢失</van-checkbox>
              </van-checkbox-group>
            </div> -->
            <div class="right">
              <div>
                正常数量&emsp;<el-input-number
                  v-model="num"
                  :min="0"
                  :max="Number(object.num - object.returnNum - object.errorNum)"
                ></el-input-number>
              </div>
              <div>
                损坏数量&emsp;<el-input-number
                  v-model="damageNum"
                  :min="0"
                  :max="Number(object.num - object.returnNum - object.errorNum)"
                ></el-input-number>
              </div>
              <div>
                丢失数量&emsp;<el-input-number
                  v-model="loseNum"
                  :min="0"
                  :max="Number(object.num - object.returnNum - object.errorNum)"
                ></el-input-number>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div class="filed2">
          <div class="filed_label"><span>*</span>备注</div>
          <div class="filed_value">
            <van-field
              v-model="message"
              rows="5"
              autosize
              type="textarea"
              placeholder="添加一些描述"
              class="textLeft"
            />
          </div>
        </div>
      </div>
      <div class="footer" v-if="object.state == 1">
        <el-button class="btn1" @click="submit">确认</el-button>
        <el-button class="btn2" @click="goBack">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import apis from "@/apis/borrowingAnUmbrella";
export default {
  components: {},
  data() {
    return {
      object: {},
      userinfo: {},
      returnTime: moment(new Date()).format("YYYY-MM-DD HH:mm"),
      showPickerReturn: false,
      currentTimeReturn: new Date(),
      num: 0,
      damageNum: 0,
      loseNum: 0,
      radio: [],
      message: "",
      isShowType: 1,
      historyList: [],
    };
  },
  mounted() {
    const { item } = this.$route.query;
    if (item) {
      this.object = JSON.parse(item);
    }
    this.userinfo = JSON.parse(localStorage.getItem("store")).userInfo;
    this.getList();
    console.log(this.object, "this.object");
  },
  methods: {
    // 获取归还记录
    getList() {
      const params = {
        buRecordId: this.object.id,
        state: 0,
      };
      apis.returnList(params).then((res) => {
        console.log(res, "res");
        this.historyList = res.data;
        this.historyList.length > 0 &&
          this.historyList.forEach((item) => {
            item.backTime = item.backTime
              ? moment(item.backTime).format("YYYY-MM-DD HH:mm")
              : "";
            item.disposeTime = item.disposeTime
              ? moment(item.disposeTime).format("YYYY-MM-DD HH:mm")
              : "";
          });
      });
    },
    //返回
    goBack() {
      this.$router.go(-1);
    },
    //提交归还
    submit() {
      // if (!this.returnTime) return this.$message.error("请选择归还时间");
      if (!this.message) return this.$message.error("请填写备注");
      const params = {
        buRecordId: this.object.id,
        backTimeStr: moment(this.returnTime).format("YYYY-MM-DD HH:mm:ss"),
        num: Number(this.num),
        damageNum: Number(this.damageNum),
        loseNum: Number(this.loseNum),
        remark: this.message,
      };
      apis.buReturn(params).then((res) => {
        if (res.code == 200) {
          this.$message.success("归还成功");
          this.$router.go(-1);
        }
      });
    },
    //选择归还时间
    onConfirmReturn(time) {
      this.returnTime = moment(time).format("YYYY-MM-DD HH:mm");
      this.showPickerReturn = false;
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;
@media screen and (max-width: 600px) {
  .fullbox {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .fullbox {
    width: 276px * $zoom;
  }
}
.mobile {
  width: 100%;
  display: flex;
  justify-content: center;
}
.fullbox {
  font-size: 14px * $zoom;
  position: relative;
  height: 100vh;
  overflow: auto;
  padding: 30px;
  background: #f7f9fa;
  &::-webkit-scrollbar {
    display: none;
  }
  .form {
    background: #fff;
    border-radius: 30px;
    padding: 20px 30px 30px;
    .from_title {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 10px 0 30px;
      border-bottom: 1px solid #e4e6e8;
      .left {
        color: #000;
        font-size: 32px;
      }
      .right {
        .top_state {
          padding: 15px 34px;
          border-radius: 8px;
          font-size: 28px;
        }
        .top_state1 {
          color: #fe964a;
          background: #fff0e6;
        }
        .top_state2 {
          color: #0caf60;
          background: #e7f7ef;
        }
        .top_state3 {
          color: #fd6a6a;
          background: #fff0f0;
        }
      }
    }
    .filed_box {
      border: 1px solid #e4e6e8;
      padding: 15px 30px;
      border-radius: 30px;
      margin-top: 30px;
    }
    .filed {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      padding: 18px 0;
      // line-height: 80px;
      // border-bottom: 1px solid #e4e6e8;
      .filed_label {
        color: #969b9e;
        font-size: 28px;
        margin-right: 50px;
        white-space: nowrap;
        span {
          color: #ff4d4d;
        }
      }
      .filed_value {
        color: #000;
        font-size: 28px;
        text-align: right;
        ::v-deep {
          .textRight {
            .van-field__control {
              text-align: right !important;
            }
          }
        }
        // font-weight: bold;
      }
    }
    .filed2 {
      margin-top: 30px;
      .filed_label {
        color: #969b9e;
        font-size: 28px;
        margin-right: 50px;
        white-space: nowrap;
        span {
          color: #ff4d4d;
        }
      }
      .filed_value {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin-top: 20px;
        ::v-deep {
          .el-input-number {
            border-radius: 100px;
            width: 190px;
            .el-input-number__decrease,
            .el-input-number__increase {
              border: none;
              background: none;
              color: #4fa27d;
              line-height: 65px;
              width: 70px;
              i {
                font-size: 30px;
                font-weight: bold;
              }
            }
            .el-input--mini .el-input__inner {
              height: 60px;
              line-height: 60px;
              border-radius: 50px;
            }
          }
          .van-cell {
            padding: 0;
          }
          .textLeft {
            .van-field__control {
              text-align: left;
              border: 1px solid #e4e6e8;
              border-radius: 30px;
              padding: 20px 30px;
            }
          }
        }
        .left {
          margin-top: 10px;
          ::v-deep {
            .van-checkbox {
              margin-bottom: 50px;
            }
            .van-checkbox__label {
              font-size: 28px;
            }
            .van-checkbox__icon--checked .van-icon {
              background: none;
              color: #4fa27d;
              border-radius: 6px;
              border: 2px solid #000;
            }
          }
        }
        .right {
          // display: flex;
          // align-items: center;
          font-size: 28px;
          color: #969b9e;
          div {
            margin-bottom: 14px;
          }
        }
      }
    }
    .line {
      width: 100%;
      height: 1px;
      background: #e4e6e8;
      margin: 10px 0;
    }
    .from_text {
      width: 100%;
      background: #4fa27d;
      border-radius: 30px;
      padding: 40px 0;
      display: flex;
      align-items: center;
      font-size: 26px;
      margin-top: 30px;
      color: #fff;
      .left,
      .right {
        width: 50%;
        text-align: center;
        .value {
          font-size: 34px;
          margin-top: 10px;
        }
      }
    }
  }
  .footer {
    .btn2 {
      border: none;
      background: none;
      color: #969b9e;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 0 0 30px !important;
      border-radius: 15px;
    }
    .btn1 {
      background: #4fa27d;
      color: #fff;
      width: 100%;
      height: 85px;
      font-size: 10px * $zoom;
      margin: 50px 0 30px;
      border-radius: 15px;
    }
  }
}
</style>
